import { useEffect } from 'react';
import pick from 'lodash/pick';
import { useDispatch, useSelector } from 'react-redux';
import { getOrderByNumber } from '../../../selectors';
import { createLoadOrder } from '../../../actions/order';

/**
 * Selects the full order for a search host and loads it if not yet loaded,
 * so already-added products render as "Added". Skipped for collections.
 */
export function useFullOrder(order?: { form_number?: string; order_type?: string } | null) {
  const dispatch = useDispatch();
  const fullOrder = useSelector((state: any) =>
    getOrderByNumber(state, pick(order, ['form_number', 'order_type']))
  );

  useEffect(() => {
    if ('COLLECTION' === order?.order_type) {
      return;
    }
    if (fullOrder && !fullOrder.loaded) {
      dispatch(createLoadOrder(fullOrder.order_id));
    }
    // Keying on loaded/order_id (not the full_order object, whose identity
    // changes every store update) prevents re-dispatching the load while one
    // is already in flight.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [order?.order_type, fullOrder?.loaded, fullOrder?.order_id, dispatch]);

  return fullOrder;
}
